export default "__VITE_ASSET__7bcd9f2c__"